import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: "var(--text-color-default)",
  height: 3,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 32,
    width: 32,
    backgroundColor: "red",
    boxShadow: iOSBoxShadow,
    marginTop: -16,
    marginLeft: -16,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      "@media (hover: none)": {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  "& .MuiSlider-valueLabel": {
    left: "calc(-40% + 12px)",
    top: 10,
    "& *": {
      background: "transparent",
      color: "#ffffff",
    },
  },
  "& .MuiSlider-track": {
    height: 3,
  },
  "& .MuiSlider-rail": {
    height: 3,
    opacity: 1,
    backgroundColor: "var(--text-color-default)",
  },
}));

export default IOSSlider;
